module.exports = __webpack_public_path__ + "static/media/video_placeholder.91075285.png";